import PublicNewsie from "Components/Games/Newsie/PublicNewsie";
import PublicCrossword from "Components/Games/Crossword/PublicCrossword";
import PublicWordSearch from "Components/Games/WordSearch/PublicWordSearch";
import PublicQuiz from "Components/Games/Quiz/PublicQuiz";

const PublicPuzzle = (props) => {
  const { puzzleType, puzzle, postcastUser } = props;
  if (puzzleType === "newsie") {
    return (
      <PublicNewsie
        postcastUser={postcastUser}
        newsieGrid={puzzle?.newsieGrid || [[]]}
        takeAwayPoints={puzzle?.takeAwayPoints}
        solvedStories={puzzle?.solvedStories}
      />
    );
  }
  if (puzzleType === "crossword") {
    return (
      <PublicCrossword
        postcastUser={postcastUser}
        crosswordGrid={puzzle.grid || [[]]}
        wordsAndClues={puzzle?.wordsAndClues}
        selectedCell={puzzle?.selectedCell}
        clues={puzzle?.clues}
        selectedDirection={puzzle?.selectedDirection}
      />
    );
  }
  if (puzzleType === "wordsearch") {
    return (
      <PublicWordSearch
        postcastUser={postcastUser}
        wordsearchGrid={puzzle.grid || [[]]}
        words={puzzle?.words}
        solvedWords={puzzle?.solvedWords}
      />
    );
  }

  if (puzzleType === "quiz") {
    return (
      <PublicQuiz postcastUser={postcastUser} questions={puzzle.questions} />
    );
  }
  return () => <>None</>;
};

export default PublicPuzzle;
